export var DownloadButtonMode;
(function (DownloadButtonMode) {
    DownloadButtonMode[DownloadButtonMode["FREE"] = 0] = "FREE";
    DownloadButtonMode[DownloadButtonMode["FREE_AND_PREMIUM"] = 1] = "FREE_AND_PREMIUM";
    DownloadButtonMode[DownloadButtonMode["PREMIUM"] = 2] = "PREMIUM";
    DownloadButtonMode[DownloadButtonMode["OWNER_PREMIUM"] = 3] = "OWNER_PREMIUM";
})(DownloadButtonMode || (DownloadButtonMode = {}));
// Abstract away the process for getting the download mode. This will keep the component cleaner
export function getDownloadButtonMode(_a) {
    var isOwner = _a.isOwner, isPurchasable = _a.isPurchasable, isDownloadable = _a.isDownloadable;
    if (isPurchasable && isDownloadable) {
        return DownloadButtonMode.FREE_AND_PREMIUM;
    }
    else if (isDownloadable) {
        return DownloadButtonMode.FREE;
    }
    if (isOwner && isPurchasable) {
        return DownloadButtonMode.OWNER_PREMIUM;
    }
    else if (isPurchasable) {
        return DownloadButtonMode.PREMIUM;
    }
    return DownloadButtonMode.FREE;
}
//# sourceMappingURL=utils.js.map